module.exports = __webpack_public_path__ + "static/media/promheadshot.978a2b1b.png";